module.exports = __webpack_public_path__ + "img/left_building_designs.1dc108e7.png";